import React, { useCallback, useEffect, useState } from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableRow, TextField, Paper, Select, MenuItem
} from "@material-ui/core";
import UseStyles from '../../Summary/UseStyles';
import { useMemo } from 'react';
import moment from 'moment';
import GoogleAutoCompleteText from '../../../Principal/EditGuarantor/GoogleAddressSearch';


export default function CorporateGuarantor({ guarantor, usStates, handleChange, setGuarantorInfo }) {
    const classes = UseStyles();
    const guar = guarantor?.guarantor;
    const relationshipChoices = ["Business Partner", "Individual", "Managing Member", "Member", "Owner", "President"];
    const entityTypeChoices = ["Sole Proprietorship", "Corporation", "LLC", "LLP", "Partnership", "Other"];
    const maxDate = useMemo(() => moment(new Date()).format('YYYY-MM-DD'), []);
    const minDate = useMemo(() => moment(new Date()).subtract(100, 'years').format('YYYY-MM-DD'), []);
    const [yearInBusiness, setYearInBusness] = useState(null);

    useEffect(() => {
        if (yearInBusiness === null && guar?.business_start_date) {
            const diff = moment(guar?.business_start_date).diff(moment(), 'milliseconds');
            let duration = moment.duration(diff);
            duration = `${(duration.years() + (duration.months() / 100)) * -1}`
            setYearInBusness(Number(duration).toFixed(2))
        }
    }, [guar?.business_start_date, yearInBusiness]);

    const handlebusnessChange = useCallback((e) => {
        const { value } = e.target;
        e.target.name = "business_start_date";
        const yearmonths = value.split(".");
        if (isNaN(yearmonths[0]))
            return
        if ((!yearmonths[1] || Number(yearmonths[1]) < 13)) {
            setYearInBusness(value);
            e.target.value = moment(new Date()).subtract(yearmonths[0], 'years').subtract(yearmonths[1], 'months').format('YYYY-MM-DD');
            handleChange(e, true)
        }
    }, [handleChange]);

    const [googleAddress, setGoogleAddress] = useState("");

    const updateMapInfo = (mapInfo) => {
        if (mapInfo.city) {
            setGoogleAddress(mapInfo.location);
            setGuarantorInfo((pre)=>({
                ...pre,
                guarantor: {
                    ...pre.guarantor,
                    address: mapInfo.streetNumber + " " + mapInfo.street,
                    city: mapInfo.city || "",
                    county: mapInfo.country || "",
                    state: mapInfo.stateCode.label || "",
                    zip_code: mapInfo.zipCode || "",
                }
            }))

        }
    };

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
                <TableBody>
                    <TableRow className={classes.row_color1}>
                        <TableCell style={{ width: "19%" }} className={classes.cell_header_bold} align="right">
                            Relationship to Applicant
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <Select
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                variant="filled"
                                value={guarantor?.relationship_to_applicant ?? ""}
                                style={{
                                    width: "100%",
                                    marginTop: "3px",
                                    marginLeft: "3px",
                                }}
                                name="relationship_to_applicant"
                                id="relationship_to_applicant"
                                onChange={e => handleChange(e, false)}>
                                {relationshipChoices.map((item, index) => (
                                    <MenuItem key={index} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Organization Name*
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter Organization Name"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.organization_name ?? ""}
                                name="organization_name"
                                id="organization_name"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Ownership %*
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter % of Ownership"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guarantor?.percent_of_ownership?.toString() ?? ""}
                                name="percent_of_ownership"
                                id="percent_of_ownership"
                                onChange={e => handleChange(e, false)}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow className={classes.row_color2}>
                        <TableCell style={{ width: "19%" }} className={classes.cell_header_bold} align="right">
                            Business Entity Type
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <Select
                                variant="filled"
                                value={guarantor?.business_entity_type || ""}
                                style={{
                                    width: "100%",
                                    marginTop: "3px",
                                    marginLeft: "3px",
                                }}
                                name="business_entity_type"
                                id="business_entity_type"
                                onChange={e => handleChange(e, false)}>
                                {entityTypeChoices.map((item, index) => (
                                    <MenuItem key={index} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            FEIN*
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter FEIN"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.fein ?? ""}
                                name="fein"
                                id="fein"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Mobile
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter Mobile #"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.mobile ?? ""}
                                name="mobile"
                                id="mobile"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow className={classes.row_color1}>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            State of Incorporation
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <Select
                                name="state_of_incorporation"
                                id="state_of_incorporation"
                                value={guar?.state_of_incorporation ?? ""}
                                variant="filled"
                                style={{
                                    width: "100%",
                                    marginTop: "3px",
                                    marginLeft: "3px",
                                }}
                                onChange={e => handleChange(e, true)}>
                                {usStates.map((item, index) => (
                                    <MenuItem key={index} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Years In Business
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter Years In Business"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={yearInBusiness}
                                name="year_in_business"
                                id="year_in_business"
                                onChange={handlebusnessChange}
                            />
                        </TableCell>
                        <TableCell style={{ width: "19%" }} className={classes.cell_header_bold} align="right">
                            Telephone*
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter Telephone #"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.telephone ?? ""}
                                name="telephone"
                                id="telephone"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow className={classes.row_color1}>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Business Start Date*
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter Business Start Date"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                    max: maxDate,
                                    min: minDate
                                }}
                                style={{
                                    width: "100%",
                                }}
                                value={guar?.business_start_date ?? ""}
                                name="business_start_date"
                                id="business_start_date"
                                type="date"
                                onChange={e => { handleChange(e, true); setYearInBusness(null); }}
                                error={moment(guar?.business_start_date).format('YYYY-MM-DD') > maxDate}
                            />
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Email
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter email"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.email ?? ""}
                                name="email"
                                id="email"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Fax
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter Fax #"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.fax ?? ""}
                                name="fax"
                                id="fax"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow className={classes.row_color2}>
                        <TableCell style={{ width: "19%" }} className={classes.cell_header_bold} align="right" >
                        Search Address
                        </TableCell>
                        <TableCell style={{ width: "17%" }} colSpan={5}>
                            <GoogleAutoCompleteText
                                id={"map-address-1"}
                                variant="outlined"
                                className="gps_address_input"
                                placeholder="Enter address"
                                value={googleAddress}
                                setGoogleAddress={setGoogleAddress}
                                onMapChanged={updateMapInfo}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow className={classes.row_color2}>
                        <TableCell style={{ width: "19%" }} className={classes.cell_header_bold} align="right" >
                           
                            Street Address*
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left" >
                            <TextField
                                placeholder="Enter Address 1"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.address ?? ""}
                                name="address"
                                id="address"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Address 2
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter Address 2"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.address_2 ?? ""}
                                name="address_2"
                                id="address_2"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            County
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter County"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.county ?? ""}
                                name="county"
                                id="county"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                    </TableRow>
                    < TableRow className={classes.row_color1}>
                        <TableCell style={{ width: "19%" }} className={classes.cell_header_bold} align="right">
                            City*
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter City"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.city ?? ""}
                                name="city"
                                id="city"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            State*
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <Select
                                variant="filled"
                                value={guar?.state ?? ""}
                                style={{
                                    width: "100%",
                                    marginTop: "3px",
                                    marginLeft: "3px",
                                }}
                                name="state"
                                id="state"
                                onChange={e => handleChange(e, true)}>
                                {usStates.map((item, index) => (
                                    <MenuItem key={index} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Zip*
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter Zip"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.zip_code ?? ""}
                                name="zip_code"
                                id="zip_code"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer >
    )
}
